import script from "./Teams.vue?vue&type=script&setup=true&lang=js"
export * from "./Teams.vue?vue&type=script&setup=true&lang=js"

import "./Teams.vue?vue&type=style&index=0&id=045c179e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/INPEOPLE-HUB/INPEOPLE-HUB/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-045c179e"]])

export default __exports__